// Hand-kept mirror of internal/devprops/quickadd.go's QuickAddSpecs. Keep the
// two in sync — this drives the "Quick Add" pills/rows in
// StructuredPropertiesEditor; the Go table is the source of truth and
// re-validates every value server-side regardless of what's enforced here.

export interface QuickAddSpec {
  propertyId: string;
  label: string;
  format: string;
  // Client-side format check mirroring the Go validator. Undefined = free text.
  pattern?: RegExp;
  patternError?: string;
}

export const QUICK_ADD_SPECS: QuickAddSpec[] = [
  {
    propertyId: "VENDOR_ID",
    label: "Vendor ID",
    format: "e.g. 1",
    pattern: /^[0-9]+$/,
    patternError: "must be a decimal integer",
  },
  { propertyId: "VENDOR_NAME", label: "Vendor Name", format: "e.g. Rockwell Automation" },
  { propertyId: "PRODUCT_NAME", label: "Product Name", format: "e.g. 1756-L85E" },
  {
    propertyId: "PRODUCT_CODE",
    label: "Product Code",
    format: "e.g. 166",
    pattern: /^[0-9]+$/,
    patternError: "must be a decimal integer",
  },
  { propertyId: "DEVICE_TYPE", label: "Device Type", format: "e.g. Programmable Logic Controller" },
  {
    propertyId: "SERIAL_NUMBER",
    label: "Serial Number",
    format: "e.g. 0x00A1B2C3",
    pattern: /^0[xX][0-9A-Fa-f]+$/,
    patternError: "must be a hex string, e.g. 0x00A1B2C3",
  },
];

// The reserved qualifiedName namespace a custom attribute must not collide
// with — every quick-add property plus the two fixed fields.
export const RESERVED_PROPERTY_IDS: string[] = [
  "FIRMWARE_VERSION",
  "SOFTWARE_VERSION",
  ...QUICK_ADD_SPECS.map((s) => s.propertyId),
];

// normalizeCustomName mirrors devprops.normalizeCustomName (Go) —
// UPPER_SNAKE_CASE, non-alphanumeric runs collapsed to a single underscore,
// leading/trailing underscores trimmed.
export function normalizeCustomName(name: string): string {
  const upper = name.trim().toUpperCase();
  const normalized = upper.replace(/[^A-Z0-9]+/g, "_");
  return normalized.replace(/^_+|_+$/g, "");
}
